import React from 'react'
import Layout from '../../layout'

import AllVendors from './allVendors'

const Vendors: React.FC = () => {
  return (
    <Layout>
      <AllVendors />
    </Layout>
  )
}

export default Vendors
